import lodash from 'lodash'
import deepdash from 'deepdash'
import uuid from 'uuid/v4'
import {
  FETCH_NOTIFICATION_SETTINGS,
  FETCH_NOTIFICATION_SETTINGS_SUCCEEDED,
  POST_NOTIFICATION_SETTINGS,
  POST_NOTIFICATION_SETTINGS_SUCCEEDED,
  UPDATE_NOTIFICATION_SETTING,
} from './index'

const _ = deepdash(lodash)

export const appNotificationSettings = (state = {}, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_SETTINGS:
    case POST_NOTIFICATION_SETTINGS:
      return {
        ...state,
      }

    case FETCH_NOTIFICATION_SETTINGS_SUCCEEDED:
      return {
        ...addValueRefs(action.payload.result.notificationSettings),
      }
    case POST_NOTIFICATION_SETTINGS_SUCCEEDED:
      return {
        ...addValueRefs(action.payload.notificationSettings),
      }
    case UPDATE_NOTIFICATION_SETTING:
      return {
        ...state,
        ...updateValueByRef(state, action.valueRef, action.newValue),
      }
    default:
      return state
  }
}

export const appNotificationSettingsPending = (state = {}, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_SETTINGS:
    case POST_NOTIFICATION_SETTINGS:
      return true

    case FETCH_NOTIFICATION_SETTINGS_SUCCEEDED:
      return false
    case POST_NOTIFICATION_SETTINGS_SUCCEEDED:
      return false
    default:
      return state
  }
}

export const appNotificationSettingsLoaded = (state = {}, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_SETTINGS:
    case POST_NOTIFICATION_SETTINGS:
      return false
    case FETCH_NOTIFICATION_SETTINGS_SUCCEEDED:
      return true
    case POST_NOTIFICATION_SETTINGS_SUCCEEDED:
      return true
    default:
      return state
  }
}

export const appNotificationSettingsUpdates = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_NOTIFICATION_SETTING:
      if (action.valueRef in state) {
        if (action.newValue === state[action.valueRef].originalValue) {
          const nextState = { ...state }
          delete nextState[action.valueRef]
          return nextState
        }
        return {
          ...state,
          ...{
            [action.valueRef]: {
              originalValue: action.previousValue,
              updatedValue: action.newValue,
            },
          },
        }
      } else {
        return {
          ...state,
          ...{
            [action.valueRef]: {
              originalValue: action.previousValue,
              updatedValue: action.newValue,
            },
          },
        }
      }
    case FETCH_NOTIFICATION_SETTINGS_SUCCEEDED:
    case POST_NOTIFICATION_SETTINGS_SUCCEEDED:
      return {}
    default:
      return state
  }
}

const addValueRefs = (o) => {
  return structuredClone(
    _.eachDeep(o, (value, key, parentValue, context) => {
      if (key === 'value') {
        parentValue.valueRef = uuid()
      }
    }),
  )
}

const updateValueByRef = (o, valueRef, newValue) => {
  return structuredClone(
    _.eachDeep(structuredClone(o), (value, key, parentValue, context) => {
      if (value === valueRef) {
        parentValue.value = newValue
      }
    }),
  )
}
